import { render, staticRenderFns } from "./InvoiceInfo.vue?vue&type=template&id=60655116"
import script from "./InvoiceInfo.vue?vue&type=script&lang=js"
export * from "./InvoiceInfo.vue?vue&type=script&lang=js"
import style0 from "./InvoiceInfo.vue?vue&type=style&index=0&id=60655116&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports